var SearchType;
(function (SearchType) {
    SearchType["EQ"] = "equal";
    SearchType["GT"] = "greater";
    SearchType["GTE"] = "greaterorequal";
    SearchType["LT"] = "less";
    SearchType["LTE"] = "lessorequal";
    SearchType["LK"] = "like";
    SearchType["NE"] = "notequal";
    SearchType["NLK"] = "notlike";
})(SearchType || (SearchType = {}));
const SearchType$1 = SearchType;

export { SearchType$1 as default };
//# sourceMappingURL=SearchType.js.map
